<template>
    <div dusk="looker-embed">
        <iframe scrolling="no" :id="id" ref="iframe" :style="{ width: '100%', height }" :src="embedUrl"></iframe>
    </div>
</template>

<script>
export default {
    props: {
        id:              String,
        embedUrl:        String,
        initialHeight:   {
            type:    String,
            default: '450px'
        },
        filters:         {
            type:    Object,
            default: () => ({})
        },
        type:            {
            type:    String,
            default: 'dashboard'
        },
    },

    data() {
        return {
            measuredHeight:        null,
            iframeInitialized:     false,
            iframeComplete:        false,
            iframeCompletePayload: null
        };
    },

    watch: {
        filters(newVal) {
            if (!this.iframeInitialized) {
                return;
            }

            const payload = {
                type:    'look:filters:update',
                filters: newVal
            };
            this.sendPayloadToIframe(payload);
        }
    },

    computed: {
        height() {
            if (this.measuredHeight) {
                return this.measuredHeight + 'px';
            }

            return this.initialHeight;
        }
    },

    methods: {
        refreshResultsWithNewDate(dateRangeString) {
            let payloads = [{
                'type':    `${this.type}:filters:update`,
                'filters': this.type === 'look' ? {
                    'Date Detail': dateRangeString
                } : {
                    // Note: the api only allows one filter at a time. If you need to pass multiple filters at the same time,
                    // pass them as separate payloads.
                    'Date': dateRangeString
                }
            }];

            this.sendPayloadToIframe(payloads);
        },

        refreshResultsWithNewFilters() {
            const payloads = {
                type:    'look:filters:update',
                filters: {}
            };

            this.filters.forEach(filter => {
                payloads
            });
        },

        sendPayloadToIframe(payload) {
            this.$refs.iframe.contentWindow.postMessage(JSON.stringify(payload), window.Portal.lookerUrl);
            this.$refs.iframe.contentWindow.postMessage(JSON.stringify({
                type: `look:run`
            }), window.Portal.lookerUrl);
        }
    },

    mounted() {
        window.addEventListener('message', event => {
            if (event.source === this.$refs.iframe.contentWindow) {
                const data = JSON.parse(event.data);

                // Dusk tests rely on these data properties to test looker
                // is behaving properly.
                if (data.type === `${this.type}:run:start`) {
                    this.iframeInitialized = true;
                } else if (data.type === `${this.type}:run:complete`) {
                    this.iframeComplete = true;
                    this.iframeCompletePayload = data[this.type];
                } else if (data.type === 'page:properties:changed') {
                    this.measuredHeight = data.height;
                }
            }
        });
    }
};
</script>

<style>
iframe {
    border: none;
}
</style>
